import styled from 'styled-components';
import { Button, Collapse, Input, Switch, Tag, Typography } from 'antd';

/* ── Page ── */

export const PageWrapper = styled.div`
  padding: 0;
`;

/* ── Header ── */

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const HeaderIconWrap = styled.span`
  color: #2d6cca;
  font-size: 22px;
  display: flex;
  align-items: center;
`;

export const PageTitle = styled(Typography.Title)`
  &.ant-typography {
    margin: 0;
  }
`;

export const AddButton = styled(Button)`
  background-color: #2d6cca !important;
  border-color: #2d6cca !important;
  color: #ffffff !important;
  &:hover {
    background-color: #1e4d8f !important;
    border-color: #1e4d8f !important;
    color: #ffffff !important;
  }
`;

export const ActionIconButton = styled.button<{ iconColor?: string }>`
  align-items: center;
  border: 1px solid #eee;
  border-radius: 10px;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 8px;
  width: 30px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  background: transparent;

  svg {
    transition: color 0.2s;
  }

  &:hover {
    background-color: ${({ iconColor }) =>
      iconColor === '#f5222d'
        ? 'rgba(245, 34, 45, 0.1)'
        : 'rgba(45, 108, 202, 0.1)'} !important;

    svg {
      color: ${({ iconColor }) => iconColor || '#2D6CCA'} !important;
    }
  }
`;

export const DrawerContentWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

/* ── Keep for ItemsHeader back-compat ── */
export const PageHeader = HeaderSection;
export const TitleSection = styled.div``;
export const ActionsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const LastUpdatedText = styled.span`
  font-size: 12px;
  color: #b0b0b0;
`;

export const HeaderSubtitle = styled.p`
  margin: 2px 0 0;
  font-size: 13px;
  color: #888;
  font-weight: 400;
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

export const RefreshIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid #e8e8e8;
  background: transparent;
  color: #666;
  cursor: pointer;
  font-size: 15px;
  transition: background 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background: #f0f5ff;
    border-color: #2d6cca;
    color: #2d6cca;
  }
`;

/* ── Search ── */

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const SearchInputStyled = styled.input`
  width: 100%;
  padding: 12px 20px 12px 46px;
  border-radius: 50px;
  border: 1.5px solid #e8e8e8;
  font-size: 14px;
  outline: none;
  background: #fff;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  color: #1a1a1a;

  &::placeholder {
    color: #c0c0c0;
  }

  &:focus {
    border-color: #2d6cca;
    box-shadow: 0 0 0 3px rgba(45, 108, 202, 0.1);
  }
`;

export const SearchInput = SearchInputStyled;

export const SearchIcon = styled.span`
  position: absolute;
  left: 17px;
  top: 50%;
  transform: translateY(-50%);
  color: #c0c0c0;
  display: flex;
  align-items: center;
  font-size: 16px;
  pointer-events: none;
`;

/* ── Table ── */

export const TableWrapper = styled.div`
  margin-top: 16px;
`;

export const ItemThumbnail = styled.img`
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const ThumbnailImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
`;

export const ItemThumbnailWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
`;

export const NoImagePlaceholder = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #f5f5f5;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c0c0;
  flex-shrink: 0;
`;

export const BadgeOverlay = styled.img`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
`;

export const PreviewImageWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const PreviewBadgeOverlay = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
`;

export const ItemEyeBadge = styled.div`
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1;
`;

export const ItemNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ItemNameText = styled.span`
  font-weight: 600;
`;

export const DescriptionText = styled.span`
  color: #888;
  font-size: 13px;
`;

export const PriceTag = styled(Tag)`
  font-weight: 700 !important;
  border-radius: 20px !important;
`;

export const RoundTag = styled(Tag)`
  border-radius: 20px !important;
`;

export const StatusTag = styled.span<{
  $variant: 'price' | 'yes-green' | 'yes-blue' | 'no';
  $isDark: boolean;
}>`
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  ${({ $variant, $isDark }) => {
    switch ($variant) {
      case 'price':
        return $isDark
          ? 'background:rgba(251,191,36,0.12);border:1px solid rgba(251,191,36,0.3);color:#fbbf24;'
          : 'background:#fff7e6;border:1px solid #ffd591;color:#d46b08;';
      case 'yes-green':
        return $isDark
          ? 'background:rgba(52,211,153,0.12);border:1px solid rgba(52,211,153,0.3);color:#34d399;'
          : 'background:#f6ffed;border:1px solid #b7eb8f;color:#389e0d;';
      case 'yes-blue':
        return $isDark
          ? 'background:rgba(96,165,250,0.12);border:1px solid rgba(96,165,250,0.3);color:#60a5fa;'
          : 'background:#e6f7ff;border:1px solid #91d5ff;color:#0958d9;';
      case 'no':
        return $isDark
          ? 'background:rgba(156,163,175,0.08);border:1px solid rgba(156,163,175,0.2);color:#6b7280;'
          : 'background:#fafafa;border:1px solid #d9d9d9;color:#8c8c8c;';
    }
  }}
`;

export const SoldOutSwitchWrap = styled.div<{ $busy: boolean }>`
  display: inline-block;
  cursor: ${({ $busy }) => ($busy ? 'not-allowed' : 'pointer')};
`;

export const SoldOutSwitch = styled(Switch).withConfig({
  shouldForwardProp: (prop) => prop !== '$soldOut',
})<{ $soldOut?: boolean }>`
  ${({ $soldOut }) => $soldOut && 'background: #ff4d4f !important;'}
`;

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

export const PreviewImg = styled.img`
  max-width: 80vw;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
`;

/* ── Form Modal ── */

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ModalScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px 8px;
`;

export const ModalFooter = styled.div<{ $isDark: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  border-top: 1px solid ${({ $isDark }) => ($isDark ? '#434343' : '#f0f0f0')};
  background: ${({ $isDark }) => ($isDark ? '#1a202c' : '#ffffff')};
  flex-shrink: 0;
`;

export const CancelButton = styled(Button)`
  min-width: 100px;
`;

export const FormSubmitButton = styled(AddButton)`
  min-width: 130px;
  font-weight: 600;
`;

export const FormField = styled.div`
  margin-bottom: 18px;
`;

export const FormLabel = styled.label<{ $isDark?: boolean }>`
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 13px;
  color: ${({ $isDark }) => ($isDark ? '#a0a0a0' : '#555')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FormSectionTitle = styled.div<{ $isDark?: boolean }>`
  font-size: 11px;
  font-weight: 600;
  color: ${({ $isDark }) => ($isDark ? '#a0a0a0' : '#555')};
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

export const RequiredMark = styled.span`
  color: #ff4d4f;
  margin-left: 2px;
  font-weight: 700;
`;

export const OptionalTag = styled.span`
  color: #777;
  font-size: 11px;
  font-weight: 400;
  margin-left: 4px;
`;

export const FieldError = styled.span`
  font-size: 12px;
  color: #ff4d4f;
  display: block;
  margin-top: 4px;
`;

export const FixedTextArea = styled(Input.TextArea)`
  textarea& {
    resize: none;
  }
`;

export const FormDivider = styled.hr<{ $isDark: boolean }>`
  margin: 16px 0;
  border: 0;
  border-top: 1px solid ${({ $isDark }) => ($isDark ? '#434343' : '#f0f0f0')};
`;

/* ── Settings switches ── */

export const SettingsSection = styled.div<{ $isDark: boolean }>`
  background: ${({ $isDark }) => ($isDark ? '#242424' : '#fafafa')};
  border-radius: 12px;
  padding: 4px 0;
  margin-bottom: 16px;
`;

export const SettingsSwitchGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 0;
`;

export const SwitchRowItem = styled.div<{ $hasDivider?: boolean; $isDark?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${({ $hasDivider, $isDark }) =>
    $hasDivider &&
    `
    padding-bottom: 12px;
    border-bottom: 1px solid ${$isDark ? '#434343' : '#f0f0f0'};
    margin-bottom: 12px;
  `}
`;

export const SwitchLabel = styled.div<{ $isDark?: boolean }>`
  font-weight: 600;
  font-size: 14px;
  color: ${({ $isDark }) => ($isDark ? '#e0e0e0' : 'inherit')};
`;

export const SwitchDescription = styled.div<{ $isDark?: boolean }>`
  font-size: 12px;
  color: ${({ $isDark }) => ($isDark ? '#888' : '#666')};
`;

/* ── Collapse ── */

export const CollapseWrapper = styled(Collapse)`
  margin-bottom: 8px;
`;

export const CollapseChildrenWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CollapseTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const CollapseSubtitle = styled.span<{ $isDark?: boolean }>`
  font-size: 12px;
  color: ${({ $isDark }) => ($isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.45)')};
`;

export const CollapseSectionLabel = styled.span<{ $isDark?: boolean }>`
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ $isDark }) => ($isDark ? '#ccc' : 'inherit')};
`;

/* ── Image upload ── */

export const ImagePreviewWrapper = styled.div<{ $isDark?: boolean }>`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 2px dashed ${({ $isDark }) => ($isDark ? '#434343' : '#d9d9d9')};
  background: ${({ $isDark }) => ($isDark ? '#1f1f1f' : '#fafafa')};
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:has(img) {
    border: none;
    background: none;
  }
`;

export const ImageUploadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  border: none;
  background: #2d6cca;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 28px;
  transition: background 0.2s;

  &:hover {
    background: #1e4d8f;
  }
`;

export const ImageEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 28px 16px;
  cursor: pointer;
  color: #bbb;
  width: 100%;
`;

export const ImageEmptyIcon = styled.span`
  font-size: 40px;
  color: #c0c0c0;
`;

export const ImageEmptyText = styled.span`
  font-size: 13px;
  color: #999;
`;

export const ImagePreviewImg = styled.img`
  width: 100%;
  height: 260px;
  object-fit: cover;
  display: block;
  background: #f5f5f5;
`;

export const ImageActionButtons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
`;

export const ImageHint = styled.p`
  font-size: 11px;
  color: #666;
  margin: 6px 0 0;
`;

export const DeleteImageButton = styled(Button)`
  border-radius: 20px !important;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

/* ── Switch rows (legacy, kept for compatibility) ── */

export const SwitchRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px;
  background: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 16px;
`;

export const SwitchItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
`;

/* ── Selection dropdowns ── */

export const SuggestionsDropdown = styled.div<{ $isDark: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${({ $isDark }) => ($isDark ? '#1f1f1f' : '#fff')};
  border: 1.5px solid ${({ $isDark }) => ($isDark ? '#333' : '#f0f0f0')};
  border-radius: 14px;
  margin-top: 6px;
  z-index: 20;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
`;

export const SuggestionItem = styled.div<{ $isDark: boolean; $isSelectAll?: boolean }>`
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  transition: background 0.15s ease;
  ${({ $isSelectAll, $isDark }) =>
    $isSelectAll &&
    `
    font-weight: 700;
    border-bottom: 1px solid ${$isDark ? '#333' : '#f0f0f0'};
  `}

  &:hover {
    background: ${({ $isDark }) => ($isDark ? '#2a2a2a' : '#f0f5ff')};
  }

  &:first-child {
    border-radius: 14px 14px 0 0;
  }
  &:last-child {
    border-radius: 0 0 14px 14px;
  }
`;

export const DropdownLoadingWrap = styled.div`
  padding: 16px;
  text-align: center;
`;

export const DropdownEmptyMsg = styled.div`
  padding: 12px 14px;
  color: #999;
  font-size: 13px;
`;

export const SelectedItemText = styled.span`
  font-weight: 600;
`;

export const CheckIconWrap = styled.span`
  color: #52c41a;
  display: flex;
  align-items: center;
`;

export const SelectedTagsBox = styled.div<{ $isDark?: boolean }>`
  padding: 14px;
  border: 1.5px solid ${({ $isDark }) => ($isDark ? '#333' : '#e8edf5')};
  border-radius: 14px;
  margin-bottom: 16px;
  background: ${({ $isDark }) => ($isDark ? '#1a1a1a' : '#f7f9fc')};
`;

export const SelectedBoxLabel = styled.span<{ $isDark?: boolean }>`
  font-weight: 600;
  color: ${({ $isDark }) => ($isDark ? '#ccc' : '#333')};
`;

export const SelectedBoxEmpty = styled.span<{ $isDark?: boolean }>`
  display: block;
  margin-top: 8px;
  color: ${({ $isDark }) => ($isDark ? '#666' : '#888')};
`;

export const TagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

export const SelectedTagItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 6px 4px 12px;
  border-radius: 20px;
  background: linear-gradient(135deg, #e8f0fe 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
`;

export const SelectedTagClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: rgba(29, 78, 216, 0.12);
  color: #1d4ed8;
  cursor: pointer;
  font-size: 9px;
  padding: 0;
  transition: background 0.15s ease, color 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: #ef4444;
    color: #fff;
  }
`;
